export const PAGE_TEXT = {
  EMAIL: 'Email',
  PASSWORD: 'Password',
  CAPTCHA: 'Captcha',
  RPG_ADMISSION: 'RPgAdmission',
  ONLINE_APPLICATION_FOR_PHD_AND_MPHIL_ADMISSION:
    'Application for PhD and MPhil Admission',
  LOGIN: 'Login',
  LOGIN_TITLE: 'RPgAdmission (Staff)',
  SSO_LOGIN: 'Staff Login',
  DONT_HAVE_ACCOUNT: "Don't have an account? ",
  SIGNUP: 'Sign up here',
  VALID_EMAIL: 'Enter a valid email',
  VALID_PASSWORD: 'Password should be of minimum 8 characters length',
  REQUIRED_EMAIL: 'Required',
  REQUIRED_PASSWORD: 'Required',
  REQUIRED_CAPTCHA: 'Required',
  FORGOT_PASSWORD: 'Forgot password?',
  LOGIN_FAILED: 'Login failed. Please check the credentials and try again.',
  APPLY_FOR_RESEARCH_STUDIES_TITLE: 'How to Apply for Research Studies',
  APPLY_FOR_RESEARCH_STUDIES_WELCOME: `
  <h2>You can apply for admission throughout the year.</h2>
  <br>
<h2>Simply follow step 1-2-3 to start your application today!</h2>`,

  APPLY_FOR_RESEARCH_STUDIES_STEP_1: `
  <h3 style = "font-size:18px; font-weight:500; margin-bottom:1rem">Step 1</h3>
  <div style = "margin-bottom:1rem">Open an account in the 
  <a target = "_blank"  href="/">RPgAdmission system</a>
    <ul style = "list-style-type: disc; margin-left:1.5rem;">
    <li>Tell us who you are, where you are from and how to contact you. </li>
    <li>Provide your education/ professional/ employment background. </li>
  </ul>
  </div>
  <div><a target = "_blank"  href="/">Login</a> with your registered email and password
    <ul style = "list-style-type: disc; margin-left:1.5rem;">
    <li>Fill in the online application form. </li>
    <li>Save the progress and retrieve your application to continue anytime.</li>
  </ul>
  </div>
  `,

  APPLY_FOR_RESEARCH_STUDIES_STEP_2: `
<h3 style = "font-size:18px; font-weight:500; margin-bottom:1rem">Step 2<h3>
<div style = "margin-bottom:1rem">Explore our research postgraduate programmes
<ul style = "list-style-type: disc; margin-left:1.5rem;">
<li>
Identify and contact <a target = "_blank"  href = "https://www.polyu.edu.hk/gs/prospective-students/find-a-supervisor/">potential supervisor(s)</a> of your research interests.
</li>
<li>
Check the <a target = "_blank"  href = "https://www.polyu.edu.hk/study/pg/research-postgraduate/admission-requirements-rpg">admission requirements</a> and 
<a target = "_blank"  href = "https://www.polyu.edu.hk/study/pg/research-postgraduate/supporting-documents-application-rpg">supporting documents</a> needed by the respective Department/ School.
</li>
<li>Read the <a target = "_blank"  href = "https://www.polyu.edu.hk/study/pg/research-postgraduate/frequently-asked-questions-rpg">FAQs</a> for additional application information.</li>
</ul>
</div>

<div>Apply timely before the deadline
<ul style = "list-style-type: disc; margin-left:1.5rem;">
<li>
Choose your preferred entry semester <a target = "_blank"  href = "https://www.polyu.edu.hk/gs/prospective-students/find-a-supervisor/">here</a> and click "Search".
</li>
<li>
Observe the application deadline of individual Departments/ Schools for specific entry periods.</li>
</ul>
</div>
  `,

  APPLY_FOR_RESEARCH_STUDIES_STEP_3: `
<h3 style = "font-size:18px; font-weight:500; margin-bottom:1rem">Step 3<h3>

<div style = "margin-bottom:1rem">Prepare your documents
<ul style = "list-style-type: disc; margin-left:1.5rem;">
<li>
Follow the <a target = "_blank" href "https://www.polyu.edu.hk/study/pg/research-postgraduate-guidelines-submitting-supporting-documents">guidelines</a> to save your academic transcripts, official examination results and other supporting documents in PDF format before uploading to the system.
</li>
</ul>
</div>

<div style = "margin-bottom:1rem">Submit your application
<ul style = "list-style-type: disc; margin-left:1.5rem;">
<li>Preview your application summary and ensure all information entered is accurate and complete.</li>
<li>
Settle the <a target = "_blank"  
  target = "_blank"
href="https://www.polyu.edu.hk/study/pg/research-postgraduate-application-fee">application fee</a> after submitting your application.
</li>
<li>Keep the application number assigned to you and quote it in future correspondence with PolyU.</li>
</ul>
</div>
  `,

  COMING_SOON: 'Coming Soon',
  AT_SEPTEMBER: 'On 1 September 2024',
  WHEN_I_SHOULD_APPLY: {
    WHEN_I_SHOULD_APPLY_TITLE: 'When should I apply?',
    APPLICATION_STARTS: 'Application Starts',
    PROGRAMME_LIST: [
      {
        ENTRY_TITLE: 'For May 2025 Entry',
        ENTRY_TIME: '1 May 2025',
        LINK: 'https://www.polyu.edu.hk/study/pg/research-postgraduate',
      },
      {
        ENTRY_TITLE: 'For January 2025 Entry',
        ENTRY_TIME: '1 January 2025',
        LINK: 'https://www.polyu.edu.hk/study/pg/research-postgraduate',
      },
      {
        ENTRY_TITLE: 'For September 2024 Entry',
        ENTRY_TIME: '1 September 2024',
        LINK: 'https://www.polyu.edu.hk/study/pg/research-postgraduate',
      },
    ],
    APPLICATION_SUBMISSION_LEADING_TIME: 'Lead time for application submission',
    LEAD_TIME_CONTENT: `
    <div>
      <p style = "margin-bottom: 0.8rem">Non-local applicants: 4 months before the commencement date of semester/term. </p>
      <p style = "margin-bottom: 0.8rem">Local applicants: 3 months before the commencement date of semester/term.</p>
      Please click <a target = "_blank" 
        href = "https://www.polyu.edu.hk/gs/current-students/useful-information-for-new-research-postgraduate-students/"
      >here</a> for information on the commencement date of each semester/term.
      </div>
    `,
  },
};

export const programmeLink = (link: string): string => `
Please click <a
href='${link}'
  target="_blank"
>here</a> to view the application deadline for individual programmes.
`;
